import { dispatch, getState } from '../../..';
import PumpingStationMotorMakeHelper, { IPumpingStationMotorMake } from '../../../../@types/model/masterData/pumpingStation/motorMake';
import GeneralFunctions from '../../../general/functions';
import MasterDataPumpingStationMotorMakeActions from './actions';

export default class MasterDataPumpingStationMotorMakeFunctions {
    private static listener : undefined | (() => void);


    public static readonly load = async () => {
        if (MasterDataPumpingStationMotorMakeFunctions.listener) return;
        
        dispatch(MasterDataPumpingStationMotorMakeActions.setLoading(true));
        dispatch(MasterDataPumpingStationMotorMakeActions.set([]));

        try {
            MasterDataPumpingStationMotorMakeFunctions.listener = PumpingStationMotorMakeHelper
                .collection()
                .onSnapshot((snapshot : firebase.firestore.QuerySnapshot<IPumpingStationMotorMake>) => {
                    const state = getState().masterData.pumpingStation.motorMake;

                    const list = state.motorMakes.slice();
                
                    const session = getState().auth.session;
                    if (!session) return;

                    // "added" | "removed" | "modified"
                    snapshot.docChanges().forEach((f) => {
                        const item = f.doc.data();
                        const index = list.findIndex(n => n.id === item.id);


                        switch (f.type) {
                            case 'added':
                                list.push(item);
                                break;
                            case 'modified':
                                list.splice(index, 1, item);
                                break;
                            case 'removed':
                                list.splice(index, 1);
                                break;
                        }
                    });

                    dispatch(MasterDataPumpingStationMotorMakeActions.set(list));
                    dispatch(MasterDataPumpingStationMotorMakeActions.setLoading(false));
                }, (ex) => {
                    GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
                    dispatch(MasterDataPumpingStationMotorMakeActions.setLoading(false));
                }, () => {
                    dispatch(MasterDataPumpingStationMotorMakeActions.setLoading(false));
                    MasterDataPumpingStationMotorMakeFunctions.listener = undefined;
                });

        } catch (ex) {
            GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
            dispatch(MasterDataPumpingStationMotorMakeActions.setLoading(false));
        }
    };
}